// extracted by mini-css-extract-plugin
export default {"mCard":"aB-z","image":"bB-z","imageNoBackground":"cB-z","imageHasCategory":"dB-z","fullWidth":"eB-z"};